export default {"src":"/_next/static/media/arrowLeftRight.336d0c27.svg","height":23,"width":23};